import { iso } from "@/lib/api";

export const nextDayIso = (dIso) => {
  const nx = new Date(`${dIso}T12:00:00`);
  nx.setDate(nx.getDate() + 1);
  return iso(nx);
};

/** Une nuit bloquée entre les deux dates interdit la sélection. */
export const rangeIsFree = (days, startIso, endIso) => {
  let cur = startIso;
  while (cur < endIso) {
    if (days[cur] && !days[cur].available) return false;
    cur = nextDayIso(cur);
  }
  return true;
};

/** Nouvelle sélection {start, end} après un clic sur dIso. */
export const nextSelection = (range, dIso, days) => {
  if (!range?.start || range.end || dIso <= range.start) return { start: dIso, end: null };
  if (!rangeIsFree(days, range.start, dIso)) return { start: dIso, end: null };
  return { start: range.start, end: dIso };
};
